import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import moment from 'moment';
import {
  fetchUserDataAPI,
  fetchPositionList
} from 'actions/UserActions';
import {
  confirmSalary
} from 'actions/SalaryActions';
import {getURL} from '../../routes';

const Pirce = (amount) => (amount < 0? '-':'+') + '$' + Math.abs(amount)

class PayrollModal extends Component{
  state = {
    confirming: false,
    chiName: '-',
    position: 1
  }

  componentDidMount() {
    let {selected, dispatch} = this.props;

    dispatch(fetchPositionList());
    fetchUserDataAPI(selected)
      .then((response) => {
        let {data} = response;
        this.setState(data);
      })
      .catch((e) => {
      })
  }

  handleConfirm = (url) => {
    return () => {
      let {selected, year, month} = this.props;
      this.setState({
        confirming: true,
      });
      confirmSalary(selected, year, month)
        .then((response) => {
          this.setState({confirming: false});
          window.open(getURL(url), "_blank");
        })
        .catch((error) => {
          alert("確認失敗");
          this.setState({confirming: false});
        })
    }
  }

  render() {
    let {
      year, month, dismiss, 
      selected, positionList,
      dailySalary, salaryAdjust, adjustmentTypeList,
      normalShift, otShift, shiftPayRecord
    } = this.props;
    let {chiName, role} = this.state;
    let position = positionList.getIn([positionList.findIndex(position => position.get('id') === role), 'name'])
    let daysInMonth = moment(year + "-" + month, "YYYY-MM").daysInMonth();
    let netTotal = (normalShift + otShift) * dailySalary;

    return (
      <Modal.Dialog className="payroll-modal">
        <Modal.Header>
          <Modal.Title>
            工數表
            <span 
              className="btn btn-danger btn-xs dismiss-btn glyphicon glyphicon-remove"
              onClick={dismiss}>
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-hover user-info">
            <tbody>
              <tr>
                <td>姓名：</td>
                <td>{chiName}</td>
                <td>職位：</td>
                <td>{position}</td>
                <td>日薪：</td>
                <td>${dailySalary}</td>
                <td>月份：</td>
                <td>{year + "-" + month}</td>
              </tr>
            </tbody>
          </table>

          <table className="table table-hover shift-info">
            <tbody>
              <tr>
                <th className="date">日期</th>
                <th className="shift">上午</th>
                <th className="shift">下午</th>
                <th className="shift">加班</th>
                <th className="date">日期</th>
                <th className="shift">上午</th>
                <th className="shift">下午</th>
                <th className="shift">加班</th>
              </tr>
              {[...Array(16).keys()].map((date)=> {
                date += 1;
                let next = date + 16;
                if (date < 10) date = "0" + date;
                return (
                  <tr>
                    <td className="date">{date}</td>
                    <td className="shift">{shiftPayRecord[date + '-0'] || '-'}</td>
                    <td className="shift">{shiftPayRecord[date + '-1'] || '-'}</td>
                    <td className="shift">{shiftPayRecord[date + '-2'] || '-'}</td>
                    <td className="date">{next <= daysInMonth? next : '-'}</td>
                    <td className="shift">{shiftPayRecord[next + '-0'] || '-'}</td>
                    <td className="shift">{shiftPayRecord[next + '-1'] || '-'}</td>
                    <td className="shift">{shiftPayRecord[next + '-2'] || '-'}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <table className="table table-hover salary-info">
            <tbody>
              <tr>
                <td>工數：</td>
                <td>{normalShift}</td>
                <td>加班：</td>
                <td>{otShift}</td>
                <td>總工數：</td>
                <td>{normalShift + otShift}</td>
                <td>工資：</td>
                <td>${(normalShift + otShift) * dailySalary}</td>
              </tr>
              <tr>
                <th colSpan={8}>其他收入/扣款</th>
              </tr>
              {salaryAdjust.map(adjustment => {
                let typeID = adjustment.get('typeID');
                let amount = adjustment.get('amount');
                let note = adjustment.get('note');
                netTotal += amount;
                return (
                  <tr>
                    <td className="adjustment-detail" colSpan={7}>
                      {adjustmentTypeList.getIn([adjustmentTypeList.findIndex(type => type.get('id') === typeID), 'name'])}  
                      {note && " - " + note}
                    </td>
                    <td>{Pirce(amount)}</td>
                  </tr>
                )
              })}
              <tr>
                <td colSpan={7}>淨薪金</td>
                <td>{Pirce(netTotal)}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>              
          <button 
            className="btn btn-primary"
            disabled={this.state.confirming} 
            onClick={this.handleConfirm(`/ws-admin/report/payroll/${selected}/${year}/${month}`)}>
            確認并匯出工數表
          </button>
          <button 
            className="btn btn-primary"
            disabled={this.state.confirming} 
            onClick={this.handleConfirm(`/ws-admin/report/receipt/${selected}/${year}/${month}`)}>
            確認并匯出工資單
          </button>
          <button 
            className="btn btn-default"
            onClick={dismiss}>
            關閉
          </button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}

export default PayrollModal;


// WEBPACK FOOTER //
// ./src/components/Salary/PayrollModal.js